import { useState } from "react";
import { Calendar as CalendarIcon, X as XIcon } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

// yyyy-mm-dd <-> Date helpers (local, no UTC shift)
const toYmd = (d) => {
  if (!d) return "";
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};
const fromYmd = (s) => {
  if (!s) return undefined;
  const [y, m, d] = s.split("-").map(Number);
  if (!y || !m || !d) return undefined;
  return new Date(y, m - 1, d);
};
const human = (s) => {
  const d = fromYmd(s);
  if (!d) return "";
  return d.toLocaleDateString("en-CA", { year: "numeric", month: "short", day: "2-digit" });
};

export default function DatePicker({ value, onChange, placeholder = "Pick a date", testId, allowClear = true }) {
  const [open, setOpen] = useState(false);
  const selected = fromYmd(value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testId}
          className="w-full flex items-center justify-between gap-2 bg-black border border-white/20 hover:border-wutn focus:border-wutn px-3 py-2.5 text-white outline-none transition-colors text-sm"
        >
          <span className="flex items-center gap-2">
            <CalendarIcon className="h-4 w-4 text-wutn" />
            <span className={value ? "text-white" : "text-zinc-500"}>{value ? human(value) : placeholder}</span>
          </span>
          {allowClear && value && (
            <span
              role="button"
              tabIndex={-1}
              aria-label="Clear"
              onClick={(e) => { e.stopPropagation(); onChange(""); }}
              className="p-1 text-zinc-500 hover:text-wutn rounded-sm"
            >
              <XIcon className="h-3.5 w-3.5" />
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-auto p-0 bg-black border border-white/20 rounded-none">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => { onChange(toYmd(d)); setOpen(false); }}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
